import {
  MEETING_HISTORY,
  CREATE_MEETING,
  POC_LIST_DROPDOWN,
  MEETING_BY_ID,
  CANCEL_MEETING,
  COMPLETE_MEETING,
  VIEW_MOM,
  FEEDBACK,
  FEEDBACK_BY_ID,
  GET_INVOICES,
  CHEQUE_PICKED_LIST,
  SAVE_DRAFT_MEETING,
  SAVE_AS_DRAFT_DATA,
  DISCARD_DRAFT,
  CHECK_IN_MEETING,
  CX_ORDER_REFUND_LIST, 
  CX_ORDER_REFUND_DATA, 
  CX_ORDER_REFUND_APPROVAL, 
  USERS_LIST_FOR_HOD,
  SAVE_USER_RATING_BY_HOD,
  USER_DATA_BY_USER_ID,
  GET_JUNIOR_LIST,
  SAVE_MEETING_RATING_BY_SENIOR,
  EMAIL_DROPDOWN_FILTER,
  SELF_SCORECARD_BY_HOD,
  SELF_SCORECARD_BY_SENIOR,
  NCS_MEETINGS,
  NCS_MEETINGS_DATA
} from "./type";

const initialState = {
  meetingList: [],
  feedbackList: [],
  meetingData: {},
  pocList: [],
  meetingById: {},
  feedbackById: {},
  cancel: [],
  complete: [],
  momBymeetingId: null,
  invoiceList: [],
  chequePickedList: [],
  saveDraftData: {},
  getDraftEditData: [],
  discardDraft: [],
  checkInForMeeting: [],
  refundList:[],
  orderRefundData:[],
  orderRefundActionData:[],
  usersListingUnderHod: [],
  saveUsersRating: [],
  userMeetingDetailsByUserId: [],
  getJuniorListForImmediateSenior: [],
  saveMeetingRatingByImmediateSenior: [],
  emailDropdownFilter: [],
  getUserScoreByHod: [],
  getUserScoreBySenior: [],
  ncsMeetings:[],
  ncsMeetingData:[]
}

const baMeetingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MEETING_HISTORY:
      return {
        ...state,
        meetingList: payload,
        meetingById: {}
      };
      case FEEDBACK:
      return {
        ...state,
        feedbackList: payload,
        feedbackById:{}
      };
      case FEEDBACK_BY_ID:
      return {
        ...state,
        feedbackById: payload,
      };
      
    case CREATE_MEETING:
      return {
        ...state,
        meetingData: payload,
      };
    case POC_LIST_DROPDOWN:
      return {
        ...state,
        pocList: payload,
      };
      case MEETING_BY_ID:
      return {
        ...state,
        meetingById: payload,
      };
      case CANCEL_MEETING:
      return {
        ...state,
        cancel: payload,
      };
      case COMPLETE_MEETING:
      return {
        ...state,
        complete: payload,
      };
      case VIEW_MOM:
      return {
        ...state,
        momBymeetingId: payload,
      };
      case GET_INVOICES:
      return {
        ...state,
        invoiceList: payload,
      };
      case CHEQUE_PICKED_LIST:
      return {
        ...state,
        chequePickedList: payload,
      };
      case SAVE_DRAFT_MEETING:
      return {
        ...state,
        saveDraftData: payload,
      };
      case SAVE_AS_DRAFT_DATA:
        return {
          ...state,
          getDraftEditData: payload,
        };
      case DISCARD_DRAFT:
        return {
          ...state,
          discardDraft: payload,
        };
      case CHECK_IN_MEETING:
        return {
          ...state,
          checkInForMeeting: payload,
        };
    case CX_ORDER_REFUND_LIST:
      return {
        ...state,
        refundList: payload,
      };
    case CX_ORDER_REFUND_DATA:
      return {
        ...state,
        orderRefundData: payload,
      };
    case CX_ORDER_REFUND_APPROVAL:
      return {
        ...state,
        orderRefundActionData: payload,
      };
    case USERS_LIST_FOR_HOD:
      return {
        ...state,
        usersListingUnderHod: payload,
      };
    case SAVE_USER_RATING_BY_HOD:
      return {
       ...state,
        saveUsersRating: payload,
      }
    case USER_DATA_BY_USER_ID:
      return {
        ...state,
        userMeetingDetailsByUserId: payload,
      }
    case GET_JUNIOR_LIST:
      return {
        ...state,
        getJuniorListForImmediateSenior: payload,
      }
    case SAVE_MEETING_RATING_BY_SENIOR:
      return {
        ...state,
        saveMeetingRatingByImmediateSenior: payload,
      }
    case EMAIL_DROPDOWN_FILTER:
      return {
        ...state,
        emailDropdownFilter: payload,
      }
    case SELF_SCORECARD_BY_HOD:
      return {
        ...state,
        getUserScoreByHod: payload,
      }
    case SELF_SCORECARD_BY_SENIOR:
      return {
        ...state,
        getUserScoreBySenior: payload,
      }
    case NCS_MEETINGS:
      return {
        ...state,
        ncsMeetings: payload,
    }
    case NCS_MEETINGS_DATA:
      return {
        ...state,
        ncsMeetingData: payload,
    }
    default:
      return {
        ...state,
      };
  }
};

export default baMeetingReducer;